export default __webpack_public_path__ + "static/media/nolocationfull.2c9cf77e.svg";